import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

/**
 * Отправляет цель в Яндекс.Метрику
 * @param goalName Имя цели
 * @param params Дополнительные параметры цели
 */
function sendYmGoal(goalName: string, params?: Record<string, any>): void {
  try {
    const ym = (window as any).ym as undefined | ((...args: any[]) => void);
    if (typeof ym === 'function') {
      if (params) {
        ym(97951132, 'reachGoal', goalName, params);
      } else {
        ym(97951132, 'reachGoal', goalName);
      }
      // Логирование успешной отправки
      // if (window.console && window.console.log) {
      //   window.console.log(`Метрика: отправлена цель "${goalName}"`, params || '');
      // }
    } else {
      // Можно добавить логирование для отладки
      // if (window.console && window.console.warn) {
      //   window.console.warn('Метрика не инициализирована или не найдена: цель', goalName);
      // }
    }
  } catch (error) {
    // Обработка ошибок
    // if (window.console && window.console.error) {
    //   window.console.error('Ошибка отправки цели в Метрику:', error);
    // }
  }
}

document.addEventListener('DOMContentLoaded', () => {
    // Делегируем клик по SVG внутри .docs-tooltip
    document.body.addEventListener('click', (e) => {
        // Клик по кнопке закрытия тултипа
        const closeBtn = (e.target as HTMLElement).closest('.docs-tooltip__close');
        if (closeBtn) {
            const wrapper = closeBtn.closest('.docs-tooltip__wrapper');
            if (wrapper) {
                wrapper.classList.remove('active');
                e.stopPropagation();
                return;
            }
        }

        // Делегируем клик по SVG внутри .docs-tooltip
        const svg = (e.target as HTMLElement).closest('.docs-tooltip svg');
        if (svg) {
            const tooltip = svg.closest('.docs-tooltip');
            if (tooltip) {
                // Отправляем цель в метрику ПЕРЕД остановкой всплытия
                const goalAttr = tooltip.getAttribute('data-ym-goal');
                if (goalAttr && !tooltip.hasAttribute('data-ym-goal-sent')) {
                    const goalParamsAttr = tooltip.getAttribute('data-ym-params');
                    let params: Record<string, any> | undefined;
                    
                    if (goalParamsAttr) {
                        try {
                            params = JSON.parse(goalParamsAttr);
                        } catch (error) {
                            // if (window.console && window.console.warn) {
                            //     window.console.warn('Ошибка парсинга параметров цели:', goalParamsAttr, error);
                            // }
                        }
                    }
                    
                    sendYmGoal(goalAttr, params);
                    tooltip.setAttribute('data-ym-goal-sent', '1');
                }

                const wrapper = tooltip.querySelector('.docs-tooltip__wrapper') as HTMLElement | null;
                if (wrapper) {
                    // Сначала убираем active у всех тултипов
                    document.querySelectorAll('.docs-tooltip__wrapper.active').forEach((el) => {
                        el.classList.remove('active');
                    });
                    // Затем добавляем active только к текущему
                    wrapper.classList.add('active');
                    e.stopPropagation();

                    // Инициализация свайпера только для этого тултипа
                    const swiperEl = wrapper.querySelector('.docs-swiper');
                    // Теперь пагинация на том же уровне, что и .docs-swiper
                    const paginationEl = wrapper.querySelector('.swiper-pagination');
                    if (swiperEl && paginationEl && !swiperEl.classList.contains('swiper-initialized')) {
                        // @ts-ignore
                        new Swiper(swiperEl, {
                            slidesPerView: 1,
                            pagination: {
                                el: paginationEl,
                                clickable: true,
                            },
                        });
                    }
                    return;
                }
            }
        }

        // Клик вне тултипа — закрываем все
        document.querySelectorAll('.docs-tooltip__wrapper.active').forEach((el) => {
            if (!el.contains(e.target as Node)) {
                el.classList.remove('active');
            }
        });
    });

    // Закрытие тултипа при скролле
    window.addEventListener('scroll', () => {
        document.querySelectorAll('.docs-tooltip__wrapper.active').forEach((el) => {
            el.classList.remove('active');
        });
    });
});
document.addEventListener('DOMContentLoaded', function() {
    let cards = document.querySelector('.team__content__cards') as HTMLElement | null;
    if (cards) {
        cards.style.display = '';
    }
    let tooltips = document.querySelectorAll('.docs-tooltip__wrapper[style*="display: none"]');
    tooltips.forEach(function(tooltip) {
        (tooltip as HTMLElement).style.display = '';
    });
    let images = document.querySelectorAll('.docs-tooltip__content__body__image[style*="display: none"]');
    images.forEach(function(img) {
        (img as HTMLElement).style.display = '';
    });
    let headerImages = document.querySelectorAll('.docs-tooltip__content__header__image[style*="display: none"]');
    headerImages.forEach(function(img) {
        (img as HTMLElement).style.display = '';
    });
});